import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useMastermindCirclesList } from "../../hooks/community/useMastermindCirclesList";
import { LoaderOverlay } from "../../hooks/loader/LoaderOverlay";
import { CommunityDiscussionsItem } from "../community/components/CommunitySectionItem";
import { MastermindSectionEnum } from "./enums/MastermindSectionEnum";
import { useLayout } from "../../../_metronic/layout/core";
import Pagination from "../components/Pagination";

export const MastermindCirclesListPage = () => {
    const { config, setLayout } = useLayout()
    const restoreRef = useRef(config)
    const history = useHistory();
    const [section, setSection] = useState<MastermindSectionEnum>(MastermindSectionEnum.active);
    const [currentPage, setCurrentPage] = useState(1);
    const limit = 10;

    const { loading, data, toggleArchive } = useMastermindCirclesList(section, currentPage, limit);
    const list = data?.results || [];

    useEffect(() => {
        setCurrentPage(1);
    }, [section]);

    useEffect(() => {
        restoreRef.current = config

        setLayout({
            ...config,
            header: { ...config.header, display: true },
            aside: { ...config.aside, display: true },
            toolbar: { ...config.toolbar, display: false },
            footer: { ...config.footer, display: true },
        })

        document.body.classList.add('my-mastermind-circles-wrapper')

        return () => {
            document.body.classList.remove('my-mastermind-circles-wrapper')
            setLayout(restoreRef.current)
        }
    }, []);

    const totalPages = data ? Math.ceil(data.count / limit) : 1;

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    return (
        <>
            <LoaderOverlay visible={loading} message={'Loading...'} />
            <div className="my-mastermind-circles-list">
                <div className="my-mastermind-circles-list__header">
                    <h2>My Mastermind Circles</h2>
                    <button onClick={() => history.push('/my-mastermind-circles/new')}>
                        Start The Circle
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                            <path d="M8.5 0.378906L12 3.38306H0" stroke="white" />
                        </svg>
                    </button>
                </div>

                <div className="my-mastermind-circles-list__sections">
                    <button
                        className={clsx({ "active": section === MastermindSectionEnum.active })}
                        onClick={() => setSection(MastermindSectionEnum.active)}
                    >
                        Active Mastermind Circles
                    </button>
                    <div className="divider">
                        <svg xmlns="http://www.w3.org/2000/svg" width="1" height="20" viewBox="0 0 1 20" fill="none">
                            <path d="M0.5 0V20" stroke="#B4B4B4" />
                        </svg>
                    </div>
                    <button
                        className={clsx({ "active": section === MastermindSectionEnum.archived })}
                        onClick={() => setSection(MastermindSectionEnum.archived)}
                    >
                        Archived
                    </button>
                </div>

                <div className="my-mastermind-circles-list__list">
                    {list.map((l, i) => (
                        <CommunityDiscussionsItem
                            key={i}
                            id={l.id}
                            host={l.host}
                            notifications={l.notifications}
                            avatar={l.avatar}
                            author={l.author}
                            title={l.title}
                            tags={l.tags}
                            details={l.details}
                            comments={l.comments}
                            members={l.members}
                            memberComments={l.memberComments}
                            onEnter={(id) => history.push(`/community/details/${id}`)}
                            onArchive={toggleArchive}
                            onEdit={(id) => history.push(`/my-mastermind-circles/edit/${id}`)}
                        />
                    ))}
                </div>
                {list.length > 0 && data && (
                    <div className="tap-flex-center mt-5">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>
                )}
            </div>
        </>
    )
}